/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI Cloud (C) Copyright IBM Corp. 2019, 2021
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

/**
 * Create a public API to a decorator for the n-th vipr dataset
 *
 * @class DecoratorAPI
 * @hideconstructor
 * @classdesc
 */
define([], () => {
	class Events {
		getAPISpec() {
			if (!this.apiSpec) {
				this.apiSpec = {
					name: 'content API',
					features: {
						'Dashboard.Transaction': this.transaction
					},
					events :{
						propagationInfo: {
							namespace: 'content',
							info: {
								contentId: this.getId()
							},
							callStack: {
								name: 'getContent',
								params: [this.getId()]
							}
						},
						actions:{
							addContent: {
								eventName: 'child',
								type: 'add',
								isResolvePostResponse: true,
								transactionAPI: this.transaction,
								transactionParamIndex: 1,
								autoCreateTransaction: true,
								getInfo: (args, returnValue) => {
									return {
										value: args[0],
										newContentId: returnValue.getId(),
										parentId: returnValue.getContainer().getId(),
										supportsUndoRedo: true
									};
								},
								getAction: (args, returnValue) => {
									// TODO: ideally should not need to do a copy here, it should be supported by APIFactory
									// https://github.ibm.com/BusinessAnalytics/dashboard-common/blob/master/src/core/APIFactory.js#L89
									// or
									// https://github.ibm.com/BusinessAnalytics/dashboard-common/blob/master/src/core/APIFactory.js#L108
									const options = JSON.parse(JSON.stringify(args[0]));
									if (options.spec) {
										options.spec = returnValue.getFeature('Serializer').toJSON();
									}
									options.modelIdsValid = true;
									return {
										name: 'addContent',
										params: [
											options
										]
									};
								},
								getUndoActions: (args, content) => {
									void(args);
									return [{
										name: 'removeContent',
										params: content ? [content.getId()] : []
									}];
								}
							},
							removeContent: {
								eventName: 'child',
								type: 'remove',
								isResolvePostResponse: false,
								transactionParamIndex: 1,
								transactionAPI: this.transaction,
								autoCreateTransaction: true,
								getInfo: (args) => {
									return {
										value: args[0],
										supportsUndoRedo: true
									};
								},
								getUndoActions: (args) => {
									const dashboardAPI = this.dashboardFeatures.getFeature('API');
									const content = dashboardAPI.getCanvas().getContent(args[0]);
									if (content) {
										const param = {
											containerId: content.getContainer().getId(),
											spec: content.getFeature('Serializer').toJSON(),
											modelIdsValid: true
										};
										const position =  this.getContentPosition(args[0]);
										if (position !== -1) {
											param.position = position;
										}
										return [{
											name: 'addContent',
											params: [param]
										}];
									} else {
										return [];
									}
								}
							},
							setPropertyValue : {
								eventName:'property',
								getEventName: (args) => {
									return 'property:' + args[0];
								},
								getInfo: (args) => {
									const info =  {
										name: args[0],
										value: args[1],
										supportsUndoRedo: true
									};
									if(args[2]) {
										info.options = JSON.parse(JSON.stringify(args[2]));
									}
									const property = this.getPropertyList().find(property => property.id === args[0]);
									if (property) {
										if (property.onPropertyChange && property.onPropertyChange.refresh) {
											info.refresh = property.onPropertyChange.refresh;
										} else {
											info.refresh = {};
										}
										if(property.onPropertyChange && property.onPropertyChange.resizing === true) {
											info.resizing = property.onPropertyChange.resizing;
										}
									}

									return info;
								},
								getUndoActions: (args) => [{ params:[args[0], this.getPropertyValue(args[0])] }]
							}
						}
					}

				};
			}
			return this.apiSpec;
		}
	}

	return Events;
});
